import { Navigate, Route, Routes } from 'react-router-dom';
import { tabRoutes } from '../../constants/hinge-connect-constants.constant';
import { rulesRoutes } from '../constants/rules.constant';
import { useRulesPermissions } from '../hooks/use-rules-permissions';
import { CreateRuleView } from './create-rule-view';
import { ListRulesView } from './list-rules-view';
import { RuleDetailView } from './rule-detail-view';
import { RulesDashboard } from './rules-dashboard';
import { UpdateRuleView } from './update-rule-view';

/**
 * Protected route wrapper for CreateRuleView.
 * Redirects users without create permissions to the rules dashboard.
 */
const ProtectedCreateRuleView = (): JSX.Element => {
  const permissions = useRulesPermissions();

  if (!permissions.canCreate) {
    return (
      <Navigate to={`/${tabRoutes.baseRoute}/${tabRoutes.rules}`} replace />
    );
  }

  return <CreateRuleView />;
};

/**
 * Protected route wrapper for UpdateRuleView.
 * Redirects users without edit permissions to the rules dashboard.
 */
const ProtectedUpdateRuleView = (): JSX.Element => {
  const permissions = useRulesPermissions();

  if (!permissions.canEdit) {
    return (
      <Navigate to={`/${tabRoutes.baseRoute}/${tabRoutes.rules}`} replace />
    );
  }

  return <UpdateRuleView />;
};

export const RulesTab = (): JSX.Element => (
  <Routes>
    <Route path={`/${tabRoutes.rules}`} element={<RulesDashboard />} />
    <Route
      path={`/${tabRoutes.rules}/${rulesRoutes.new}`}
      element={<ProtectedCreateRuleView />}
    />
    <Route
      path={`/${tabRoutes.rules}/:id/${rulesRoutes.view}`}
      element={<RuleDetailView />}
    />
    <Route
      path={`/${tabRoutes.rules}/:id/${rulesRoutes.edit}`}
      element={<ProtectedUpdateRuleView />}
    />
    <Route
      path={`/${tabRoutes.rules}/${rulesRoutes.list}`}
      element={<ListRulesView />}
    />

    <Route
      path="*"
      element={<Navigate to={`/${tabRoutes.baseRoute}/${tabRoutes.rules}`} />}
    />
  </Routes>
);
